<main class="l-deashboard summary" [formGroup]="summaryForm">
  <div
    class="h100 l-flex-w t-boxMargin--spacebyPadding"
    style="padding-bottom: 1em; place-content: center"
  >
    <div [ngClass]="es.ExamType != 'Stress-Echo' ? 'signexam' : 'w50'">
      <div
        class="m-box"
        [ngClass]="es.ExamType != 'Stress-Echo' ? 'w50' : ''"
        *ngIf="ls.userType == 'doctor' && ps.currentPatient.ID != 'default'"
      >
        <h2>Sign Exam</h2>
        <div class="l-flex-c l-flex-w indicative-fieldset h100">
          <button class="save_patieont" *ngIf="showSign()" (click)="showlock = true">
            Sign Exam as {{ ls.getUserName() }}
          </button>
          <div *ngIf="showlock && !es.isClosed">
            Are you sure? This will lock the exam at midnight.
            <span (click)="signClose()" style="margin-left: 2em; cursor: pointer">Yes</span>
            <span (click)="showlock = false" style="margin-left: 2em; cursor: pointer">Cancel</span>
          </div>
          <span *ngIf="signed">Signed on {{ signed | date : "d-M-y H:mm:ss" }} by {{ signer }}</span>
        </div>
      </div>
    </div>
  </div>
</main>

<app-printopts
  *ngIf="showlock"
  (closed)="closePreview($event)"
  [showopts]="false"
  [signature]="true"
></app-printopts>
